export default __webpack_public_path__ + "static/media/box.ac8bbaa2.svg";